export function formatToMoscowISO(timestamp){
  if (!timestamp) return undefined;

  const date = new Date(timestamp * 1000);

  const offset = 3;
  const targetTime = new Date(date.getTime() + (offset * 60 * 60 * 1000));

  const pad = (num) => String(num).padStart(2, '0');

  const yyyy = targetTime.getUTCFullYear();
  const mm = pad(targetTime.getUTCMonth() + 1);
  const dd = pad(targetTime.getUTCDate());
  const hh = pad(targetTime.getUTCHours());
  const mi = pad(targetTime.getUTCMinutes());
  const ss = pad(targetTime.getUTCSeconds());

  return `${yyyy}-${mm}-${dd}T${hh}:${mi}:${ss}+03:00`;
};


export function toTimestamp(date) {
  if (!date) return null;

  if (typeof date === "number") {
    // Если пришёл timestamp в секундах
    if (date < 10000000000) {
      return date * 1000;
    }

    // Если уже timestamp в миллисекундах
    return date;
  }

  const timestamp = new Date(date).getTime();

  return Number.isNaN(timestamp) ? null : timestamp;
}

export function changeDateToDefault(date) {
  const timestamp = toTimestamp(date);

  if (!timestamp) return null;

  return new Date(timestamp).toISOString();
}

export function changeDateToSchema(date) {
  const iso = changeDateToDefault(date);

  if (!iso) return null;

  return iso.replace(".000Z", "+00:00");
}
